// routes
import { PATH_DASHBOARD } from "./routes/paths";

// API
// ----------------------------------------------------------------------

// export const HOST_API_KEY = typeof window !== 'undefined' ? window.location.origin : "";
export const HOST_API_KEY = process.env.REACT_APP_HOST_API_KEY || "";

export const FIREBASE_API = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APPID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: process.env.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: process.env.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
  domain: process.env.REACT_APP_AUTH0_DOMAIN,
};

// 8Base
export const EIGHT_BASE = {
  graphqlApiUrl: process.env.REACT_APP_EIGHT_BASE_GRAPHQL_API_URL,
  graphqlWsUrl: process.env.REACT_APP_EIGHT_BASE_WS_URL,
  m2mAuthProfileId: process.env.REACT_APP_EIGHT_BASE_M2M_AUTH_PROFILE_ID,
  spaAuthProfileId: process.env.REACT_APP_EIGHT_BASE_SPA_AUTH_PROFILE_ID,

  auth0Domain: process.env.REACT_APP_AUTH0_DOMAIN,
  auth0SpaClientId: process.env.REACT_APP_AUTH0_SPA_CLIENT_ID,
  eightBaseEnvironment: process.env.REACT_APP_ENVIRONMENT,
  eightBaseWorkspace: process.env.REACT_APP_WORKSPACE,
  eightBaseApiToken: process.env.REACT_APP_API_TOKEN,
  eightBaseSocketApiToken: process.env.REACT_APP_SOCKET_API_TOKEN,
  applicantToken: process.env.REACT_APP_CAREER_API_TOKEN,
};

export const MAP_API = process.env.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.home;
// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  H_MOBILE: 64,
  H_MAIN_DESKTOP: 88,
  H_DASHBOARD_DESKTOP: 70,
  H_DASHBOARD_DESKTOP_OFFSET: 92 - 32,
};

export const NAV = {
  W_BASE: 260,
  W_LARGE: 320,
  W_DASHBOARD: 280,
  W_DASHBOARD_MINI: 88,
  //
  H_DASHBOARD_ITEM: 48,
  H_DASHBOARD_ITEM_SUB: 36,
  //
  H_DASHBOARD_ITEM_HORIZONTAL: 32,
};

export const ICON = {
  NAV_ITEM: 24,
  NAV_ITEM_HORIZONTAL: 22,
  NAV_ITEM_MINI: 22,
};

export const GOOGLE_MAP_API_KEY = process.env.REACT_APP_GOOGLE_MAP_API;
